<template>
	<vue-timepicker
		:disabled="disabled"
		v-model="modelTime"
		manual-input
		input-width="7em"
		class="mb-1"
		ref="vuetimepicker"
	></vue-timepicker>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
// import moment from "moment";
export default {
	components:{
		VueTimepicker
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		value: String
	},
	computed: {
		modelTime: {
			get() {
				return this.value
				// let aux = moment(this.value);
				// console.log(this.value)
				// console.log(aux.isValid() ? aux.format("HH:mm:00") : "")
				// return aux.isValid() ? aux.format("HH:mm:00") : "";
			},
			set(v) {
				this.$emit("input", `${v}`);
			}
		}
	},
	watch:{
		value(v){
			if(v==""){
				this.$refs['vuetimepicker'].clearTime()
			}
		}
	}
};
</script>
